import { service } from "../utils/service";

// 查询公共配置 
export function getZfGgpz(params) {
  return service({
    url: "/api" + "/zfGgpz",
    method: "get",
    params
  });
}

// 新增公共配置
export function addZfGgpz(data) {
  return service({
    url: "/api" + "/zfGgpz",
    method: "post",
    data
  });
}

// 编辑公共配置
export function updataZfGgpz(data) {
  return service({
    url: "/api" + "/zfGgpz",
    method: "put",
    data
  });
}

// 编辑公共配置类型
export function ZfGgpzVerify(data) {
  return service({
    url: "/api" + "zfGgpz/verify",
    method: "post",
    data
  });
}

// 删除公共配置
export function delectZfGgpz(id) {
  return service({
    url: "/api" + "/zfGgpz/" + id,
    method: "delete",
  });
}

// 分配角色权限(新)
export function addPower(data) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/addPower",
    method: "post",
    data
  });
}

// 添加用户分配权限
export function addPowerAndStaff(data) {
  return service({
    url: "/api" + "/demay/ssm/SysStoreRole/addPowerAndStaff",
    method: "post",
    data
  });
}

// 获取用户绑定楼栋权限
export function zfFloorGetByRoleId(params) {
  return service({
    url: "/api" + "/zfFloor/getByRoleId",
    method: "get",
    params
  });
}

// 查询小区
export function getZfProperty(params) {
  return service({
    url: "/api" + "/zfProperty",
    method: "get",
    params
  });
}

// 查询所有楼栋
export function getZfPropertyFloor(params) {
  return service({
    url: "/api" + "/zfProperty/floor",
    method: "get",
    params
  });
}

// 查询当前角色关联哪些小区
export function getByRoleId(params) {
  return service({
    url: "/api" + "/zfProperty/getByRoleId",
    method: "get",
    params
  });
}

export function getZfPropertyAll(params) {
  return service({
    // url: "/api" + "/zfProperty/AllZfVo",
    url: "/api" + "/zfProperty/NewAllZfVo", //最新查询房源
    method: "get",
    params
  });
}
// 新增小区
export function addZfProperty(data) {
  return service({
    url: "/api" + "/zfProperty",
    method: "post",
    data
  });
}

// 编辑小区
export function updataZfProperty(data) {
  return service({
    url: "/api" + "/zfProperty",
    method: "put",
    data
  });
}

// 删除小区
export function deleteZfProperty(id) {
  return service({
    url: "/api" + "/zfProperty/" + id,
    method: "delete",
  });
}

// 查询小区楼栋
export function getZfFloor(params) {
  return service({
    url: "/api" + "/zfFloor",
    method: "get",
    params
  });
}

// 编辑小区楼栋
export function updataZfFloor(data) {
  return service({
    url: "/api" + "/zfFloor",
    method: "put",
    data
  });
}

// 新增小区楼栋
export function addZfFloor(data) {
  return service({
    url: "/api" + "/zfFloor",
    method: "post",
    data
  });
}
export function addzfTenant(data) {
  return service({
    url: "/api" + "/zfTenant",
    method: "post",
    data
  });
}
export function editzfTenant(data) {
  return service({
    url: "/api" + "/zfTenant",
    method: "put",
    data
  });
}
export function getzfTenant(params) {
  return service({
    url: "/api" + "/zfTenant",
    method: "get",
    params
  });
}
// 删除小区楼栋
export function deleteZfFloor(id) {
  return service({
    url: "/api" + "/zfFloor/" + id,
    method: "delete",
  });
}
export function deletezfTenant(id) {
  return service({
    url: "/api" + "/zfTenant/" + id,
    method: "delete",
  });
}

// 小区楼栋查楼层
export function getZfLevel(params) {
  return service({
    url: "/api" + "/zfLevel",
    method: "get",
    params
  });
}

// 通过楼层id查房间
export function getZfRoom(params) {
  return service({
    url: "/api" + "/zfRoom",
    method: "get",
    params
  });
}

export function pushWxPaymentNoticeByFloorIds(data) {
  return service({
    url: "/api" + "/zfNotice/pushWxPaymentNoticeByFloorIds",
    method: "post",
    data
  });
}
export function updateZfRoom(data) {
  return service({
    url: "/api" + "/zfRoom",
    method: "put",
    data
  });
}
export function deleteZfRoom(id) {
  return service({
    url: "/api" + "/zfRoom/" + id,
    method: "delete",
  });
}

// 新增楼层房间
export function addZfLevel(data) {
  return service({
    url: "/api" + "/zfLevel",
    method: "post",
    data
  });
}

// 上传房间图片
export function addZfImg(data) {
  return service({
    url: "/api" + "/zfImg",
    method: "post",
    data
  });
}

// 删除房间图片
export function delZfImg(data) {
  return service({
    url: "/api" + "/zfImg/delete",
    method: "post",
    data
  });
}

// 查询房间图片
export function getZfImg(params) {
  return service({
    url: "/api" + "/zfImg",
    method: "get",
    params
  });
}

export function addzfRoomType(data) {
  return service({
    url: "/api" + "/zfRoomType",
    method: "post",
    data
  });
}

export function updatezfRoomType(data) {
  return service({
    url: "/api" + "/zfRoomType",
    method: "put",
    data
  });
}

export function getzfRoomType(params) {
  return service({
    url: "/api" + "/zfRoomType",
    method: "get",
    params
  });
}
export function getzfProperties(params) {
  return service({
    url: "/api" + "/zfProperties",
    method: "get",
    params
  });
}
export function addzfProperties(data) {
  return service({
    url: "/api" + "/zfProperties",
    method: "post",
    data
  });
}
export function editzfProperties(data) {
  return service({
    url: "/api" + "/zfProperties",
    method: "put",
    data
  });
}
export function deletezfProperties(id) {
  return service({
    url: "/api" + "/zfProperties/" + id,
    method: "delete",
  });
}
export function addzfAppointment(data) {
  return service({
    url: "/api" + "/zfAppointment",
    method: "post",
    data
  });
}
export function getzfAppointment(params) {
  return service({
    url: "/api" + "/zfAppointment",
    method: "get",
    params
  });
}
export function updataZfRoom(data) {
  return service({
    url: "/api" + "/zfRoom/updateList",
    method: "put",
    data
  });
}
export function exchangeHouses(data) {
  return service({
    url: "/api" + "/zfCheckIn/exchangeHouses",
    method: "put",
    data
  });
}

export function addzfCheckIn(data) {
  return service({
    url: "/api" + "/zfCheckIn",
    method: "post",
    data
  });
}
export function addzfCheckInXuZu(data) {
  return service({
    url: "/api" + "/zfCheckIn/xuzu",
    method: "post",
    data
  });
}
export function editzfCheckIn(data) {
  return service({
    url: "/api" + "/zfCheckIn",
    method: "put",
    data
  });
}
export function getzfCheckIn(params) {
  return service({
    url: "/api" + "/zfCheckIn/selectNewPage",
    method: "get",
    params
  });
}


export function addzfEquipment(data) {
  return service({
    url: "/api" + "/zfEquipment",
    method: "post",
    data
  });
}
export function editzfEquipment(data) {
  return service({
    url: "/api" + "/zfEquipment",
    method: "put",
    data
  });
}

export function addzfEquipmentSzzd(data) {
  return service({
    url: "/api" + "/zfEquipment/szzd",
    method: "post",
    data
  });
}
export function deleteZfEquipment(id) {
  return service({
    url: "/api" + "/zfEquipment/" + id,
    method: "delete",
  });
}
export function getzfEquipment(params) {
  return service({
    url: "/api" + "/zfEquipment",
    method: "get",
    params
  });
}
export function addzfBill(data) {
  return service({
    url: "/api" + "/zfBill",
    method: "post",
    data
  });
}
export function updateZfBill(data) {
  return service({
    url: "/api" + "/zfBill",
    method: "put",
    data
  });
}

export function addzfCollection(data) {
  return service({
    url: "/api" + "/zfCollection",
    method: "post",
    data
  });
}
export function getzfCollection(params) {
  return service({
    url: "/api" + "/zfCollection",
    method: "get",
    params
  });
}
export function getzfBill(params) {
  return service({
    url: "/api" + "/zfBill",
    method: "get",
    params
  });
}
// export function deletezfLandlord(id) {
//   return service({
//     url: "/api" + "/zfLandlord/" + id,
//     method: "delete",
//   });
// }
export function deleteZfBill(data) {
  return service({
    url: "/api" + "/zfBill/delete",
    method: "delete",
    data
  })
}
export function zfEquipmentExportDownLoad(params) {
  return service({
    url: "/api" + "/zfEquipmentExport/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
export function getzfBillListDetail(params) {
  return service({
    url: "/api" + "/zfBill/listDetail",
    method: "get",
    params
  });
}
export function zfCheckInCheckOut(data) {
  return service({
    url: "/api" + "/zfCheckIn/checkOut",
    method: "put",
    data
  });
}
export function zfBillListHf(params) {
  return service({
    url: "/api" + "/zfBill/listHf",
    method: "get",
    params
  });
}
export function zfEquipmentExportImport(data) {
  return service({
    url: "/api" + "/zfEquipmentExport/import",
    method: "POST",
    data
  });
}
export function zfEquipmentRecordsAdd(data) {
  return service({
    url: "/api" + "/zfEquipmentRecords/add",
    method: "post",
    data
  });
}
export function getzfLandlord(params) {
  return service({
    url: "/api" + "/zfLandlord",
    method: "get",
    params
  });
}
export function listPageWx(params) {
  return service({
    url: "/api" + "/zfLandlord/listPageWx",
    method: "get",
    params
  });
}

export function getBaseStoreSlottingFee(params) {
  return service({
    url: "/api" + "/zfLandlord/getBaseStoreSlottingFee",
    method: "get",
    params
  });
}
export function addzfLandlord(data) {
  return service({
    url: "/api" + "/zfLandlord",
    method: "post",
    data
  });
}
export function addWx(data) {
  return service({
    url: "/api" + "/zfLandlord/addWx",
    method: "post",
    data
  });
}
export function editzfLandlord(data) {
  return service({
    url: "/api" + "/zfLandlord",
    method: "put",
    data
  });
}
export function deletezfLandlord(id) {
  return service({
    url: "/api" + "/zfLandlord/" + id,
    method: "delete",
  });
}

export function addzfLoss(data) {
  return service({
    url: "/api" + "/zfLoss",
    method: "post",
    data
  });
}

export function getzfLoss(params) {
  return service({
    url: "/api" + "/zfLoss",
    method: "get",
    params
  });
}

export function updatazfLoss(data) {
  return service({
    url: "/api" + "/zfLoss",
    method: "put",
    data
  });
}

export function delzfLoss(id) {
  return service({
    url: "/api" + `/zfLoss/${id}`,
    method: "delete",
  });
}

export function getzfRentDetail(params) {
  return service({
    url: "/api" + `/zfCheckIn`,
    method: "get",
    params
  });
}
export function getzfEquipmentHistory(params) {
  return service({
    url: "/api" + `/zfEquipmentHistory`,
    method: "get",
    params
  });
}

export function zfLease(params) {
  return service({
    url: "/api" + `/zfLease`,
    method: "get",
    params
  });
}

export function updataZfLease(data) {
  return service({
    url: "/api" + `/zfLease`,
    method: "put",
    data
  });
}

export function getZfLandlord(params) {
  return service({
    url: "/api" + `/zfLandlord`,
    method: "get",
    params
  });
}

export function addZfLandlord(data) {
  return service({
    url: "/api" + `/zfLandlord/add`,
    method: "post",
    data
  });
}

export function updateZfLandlord(data) {
  return service({
    url: "/api" + `/zfLandlord`,
    method: "put",
    data
  });
}

export function delZfLandlord(id) {
  return service({
    url: "/api" + `/zfLandlord/${id}`,
    method: "delete",
  });
}

export function queryZfBillVo(params) {
  return service({
    url: "/api" + `/zfBill/queryZfBillVo`,
    method: "get",
    params
  });
}

export function zfBillQueryallVo(params) {
  return service({
    url: "/api" + `/zfBill/queryallVo`,
    method: "get",
    params
  });
}

export function getZfBank(params) {
  return service({
    url: "/api" + `/zfBank`,
    method: "get",
    params
  });
}
export function getBankWx(params) {
  return service({
    url: "/api" + `/zfBank/getBankWx`,
    method: "get",
    params
  });
}

export function addZfBank(data) {
  return service({
    url: "/api" + `/zfBank`,
    method: "post",
    data
  });
}
export function addBankWx(data) {
  return service({
    url: "/api" + `/zfBank/addBankWx`,
    method: "post",
    data
  });
}

export function editZfBank(data) {
  return service({
    url: "/api" + `/zfBank`,
    method: "put",
    data
  });
}
export function putBankWx(data) {
  return service({
    url: "/api" + `/zfBank/putBankWx`,
    method: "put",
    data
  });
}

export function getzfBillListPageHz(params) {
  return service({
    url: "/api" + `/zfBill/listHz2`,
    method: "get",
    params
  });
}

export function ZfContractProperties(params) {
  return service({
    url: "/api" + `/zfContractProperties`,
    method: "get",
    params
  });
}

export function GetzfComplaint(params) {
  return service({
    url: "/api" + `/zfComplaint`,
    method: "get",
    params
  });
}

export function addZfContract(data) {
  return service({
    url: "/api" + `/zfContract`,
    method: "post",
    data
  });
}

export function GetzfReply(params) {
  return service({
    url: "/api" + `/zfReply`,
    method: "get",
    params
  })
}

export function AddzfReply(data) {
  return service({
    url: "/api" + `/zfReply`,
    method: "post",
    data
  });
}

export function getZfContract(params) {
  return service({
    url: "/api" + `/zfContract`,
    method: "get",
    params
  });
}

export function delZfContract(id) {
  return service({
    url: "/api" + `/zfContract/${id}`,
    method: "delete",
  });
}

export function updataZfContract(data) {
  return service({
    url: "/api" + `/zfContract`,
    method: "put",
    data
  });
}

export function contractSubstitutionField(params) {
  return service({
    url: "/api" + `/zfContractProperties/change`,
    method: "get",
    params
  });
}

export function zfRepair(params) {
  return service({
    url: "/api" + `/zfRepair`,
    method: "get",
    params
  });
}

export function updateZfRepairDetail(data) {
  return service({
    url: "/api" + `/zfRepairDetail`,
    method: "put",
    data
  });
}
export function zfRepairDetail(data) {
  return service({
    url: "/api" + `/zfRepairDetail`,
    method: "post",
    data
  });
}
export function updateBystatus(data) {
  return service({
    url: "/api" + `/zfRepairDetail/updateBystatus`,
    method: "post",
    data
  });
}


export function getZfRepairDetail(params) {
  return service({
    url: "/api" + `/zfRepairDetail`,
    method: "get",
    params
  });
}

// 导出房源信息接口
export function exportRoom(data) {
  return service({
    url: "/api" + "/zfRoom/exportRoom",
    method: "post",
    responseType: "blob",
    data
  });
}

export function zfRoomImport(data) {
  return service({
    url: "/api" + "/zfRoom/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
  });
}

export function zfLandlordImport(data) {
  return service({
    url: "/api" + "/zfLandlord/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
  });
}

export function zfRoomImportLease(data) {
  return service({
    url: "/api" + "/zfRoom/importLease",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
  });
}

// 导出房源模板接口
export function exportRoomTemplate(data) {
  return service({
    url: "/api" + "/zfRoom/exportRoomTemplate",
    method: "post",
    responseType: "blob",
    data
  });
}

export function exportLeaseTemplate(data) {
  return service({
    url: "/api" + "/zfRoom/exportLeaseTemplate",
    method: "post",
    responseType: "blob",
    data
  });
}

export function checkAvailableLeaseRooms(data) {
  return service({
    url: "/api" + "/zfRoom/checkAvailableLeaseRooms",
    method: "post",
    data
  });
}

// 导出房东信息接口
export function zfRoomExport() {
  return service({
    url: "/api" + `/zfRoom/export`,
    method: "post",
    responseType: "blob",
  });
}
export function putBankTl(data) {
  return service({
    url: "/api" + `/zfBank/putBankTl`,
    method: "put",
    data
  });
}
export function addTL(data) {
  return service({
    url: "/api" + `/zfLandlord/addTL`,
    method: "post",
    data
  });
}

export function listPageTl(params) {
  return service({
    url: "/api" + `/zfLandlord/listPageTl`,
    method: "get",
    params
  });
}

export function getBankTl(params) {
  return service({
    url: "/api" + `/zfBank/getBankTl`,
    method: "get",
    params
  });
}


export function getZfBankpPc(params) {
  return service({
    url: "/api" + `/zfBank/pc`,
    method: "get",
    params
  });
}
export function editZfBankpPc(data) {
  return service({
    url: "/api" + `/zfBank/pc`,
    method: "put",
    data
  });
}
export function leaseBillExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/leaseBillExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}

export function terminateTheLeaseBillExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/terminateTheLeaseBillExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
export function queryIntelligentHardwareReportExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/queryIntelligentHardwareReportExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 按日期查看流水报表导出
export function viewTransactionReportByDateExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/viewTransactionReportByDateExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 按交易方式查看流水报表导出
export function viewTransactionReportByTransactionseExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/viewTransactionReportByTransactionseExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 营业收入报表导出
export function operatingIncomeAndExpensesExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/operatingIncomeAndExpensesExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 营业分析押金详细报表（新退）导出
export function businessAnalysisDepositDetailsNewlyWithdrawnExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/businessAnalysisDepositDetailsNewlyWithdrawnExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 营业分析押金详细报表（新租）导出
export function businessAnalysisDepositDetailsNewLeaseExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/businessAnalysisDepositDetailsNewLeaseExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 营业分析房态日报报表导出`
export function dailyReportOnHousingStatusExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/dailyReportOnHousingStatusExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}
// 流水报表房源查看报表导出`
export function viewTransactionReportByPropertyExcel(params) {
  return service({
    url: "/api" + `/zfReportForms/viewTransactionReportByPropertyExcel`,
    method: "get",
    params,
    responseType: "blob",
  });
}



// WEBPACK FOOTER //
// ./src/api/room.js